var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcon03(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "#D71924"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2130_786)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.1778 37.2363L12 43.4142V45.1165L14.8838 48.0003H16.5861L22.7639 41.8224V40.1201L19.8801 37.2363H18.1778Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.1801 33.9355L21.3379 35.7777L24.2217 38.6615L26.0646 36.8185C24.9752 35.9942 24.0093 35.0284 23.1801 33.9355Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.2882 25.9301C35.8679 25.8361 36.2616 25.29 36.1677 24.7103C36.0737 24.1306 35.5276 23.7368 34.9478 23.8308C34.3681 23.9248 33.9744 24.4709 34.0683 25.0506C34.1623 25.6303 34.7085 26.0241 35.2882 25.9301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1224 19.8009C31.7319 19.8009 28.7054 23.4447 27.6465 24.8778C28.9326 26.7526 32.3466 30.1019 35.1224 29.9537C38.5136 29.9537 41.5407 26.3082 42.5988 24.8762C40.102 21.4781 37.1778 19.7497 35.1224 19.8009ZM35.1224 28.0501C33.3729 28.0501 31.9495 26.6268 31.9495 24.8773C31.9495 23.1277 33.3729 21.7044 35.1224 21.7044C36.8719 21.7044 38.2952 23.1277 38.2952 24.8773C38.2952 26.6268 36.8719 28.0501 35.1224 28.0501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.1224 12C28.0104 12 22.2449 17.7655 22.2449 24.8775C22.2449 31.9896 28.0104 37.755 35.1224 37.755C42.2344 37.755 47.9999 31.9896 47.9999 24.8775C47.9999 17.7655 42.2344 12 35.1224 12ZM35.1224 32.0632C29.2901 31.9469 25.3437 25.1984 25.1062 24.8775C25.3437 24.5565 29.2901 17.8082 35.1224 17.6918C40.9546 17.8082 44.9012 24.5566 45.1387 24.8775C44.5587 25.7812 40.7079 31.9378 35.1224 32.0632Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2130_786"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon03);
export default __webpack_public_path__ + "static/media/icon_03.70bc7c0e6de062a9658c6e2234341797.svg";
export { ForwardRef as ReactComponent };